// $ sijaa jQuery, koska koodi ei toimi muuten WordPressissä

// Menun overlay logiikka. En tiiä mitä tein, mutta toimii.
// Avaa overlayn missä näkyy accordion menu
jQuery(document).ready(function () {
  console.log("ready");
  // Menu
  jQuery(".menu-overlay-link").click(function () {
    jQuery(".menu-overlay").addClass("open");
    jQuery(".menu").addClass("open");
  });

  jQuery(".menu-overlay-link-menu").click(function () {
    jQuery(".menu-overlay").removeClass("open");
    jQuery(".menu").removeClass("open");
  });

  jQuery(".search-overlay-link-menu").click(function () {
    jQuery(".menu-overlay").removeClass("open");
    jQuery(".menu").removeClass("open");
    jQuery(".search-overlay").addClass("open");
    jQuery(".search").addClass("open");
  });

  // Search
  jQuery(".search-overlay-link").click(function () {
    jQuery(".search-overlay").addClass("open");
    jQuery(".search").addClass("open");
  });

  jQuery(".search-overlay-link-search").click(function () {
    jQuery(".search-overlay").removeClass("open");
    jQuery(".search").removeClass("open");
  });

  jQuery(".menu-overlay-link-search").click(function () {
    jQuery(".search-overlay").removeClass("open");
    jQuery(".search").removeClass("open");
    jQuery(".menu-overlay").addClass("open");
    jQuery(".menu").addClass("open");
  });

  jQuery(document).click(function (e) {
    if (jQuery(e.target).is("#sideSearch") === false) {
      //jQuery('.search-overlay').removeClass('open');
      //jQuery('.search').removeClass('open');
    }
  });
});
